<template>
    <div class="interaction-searchInput-upperRight">
        <SearchStyleButton
            @click="clickCallback"
        />
    </div>
</template>

<script setup>

import SearchStyleButton from "@/plugins/projectA/ui/searchStyleButton.vue";

const props = defineProps(["shake"])
const emits = defineEmits(["clickInput"])

function clickCallback(){
    emits("clickInput")
}

</script>

<style scoped>

@media screen and (min-width: 520px) {
    .interaction-searchInput-upperRight {
        position: absolute;
        //top: 25px;
        top: 10px;
        left: calc(50% - 150px);
        width: 300px;
        display: inline-block;
    }

    .top-search-input {
        display: inline-block;
        /*margin-right: 20px;*/
        opacity: 0.7;
    }
}

@media screen and (max-width: 520px) {
    .interaction-searchInput-upperRight {
        position: absolute;
        //top: 25px;
        top: 10px;
        left: calc(50% - 100px);
        /*left: 0;*/
        width: calc(100% - 200px);
        text-align: left;
        padding-left: 20px;
        display: inline-block;
    }

    .top-search-input {
        display: inline-block;
        /*width: 50%;*/
        margin-right: 25px;
        margin-top: 5px;
        opacity: 0.7;
    }
}

</style>